namespace GeniuzPOS.InitialData {
    export interface PsOtherPaymentForm {
        OtherPaymentType: Serenity.StringEditor;
        IsActive: Serenity.BooleanEditor;
        OtherPaymentName: Serenity.StringEditor;
        ProdImageLink: Serenity.ImageUploadEditor;
    }

    export class PsOtherPaymentForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsOtherPayment';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsOtherPaymentForm.init)  {
                PsOtherPaymentForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.ImageUploadEditor;

                Q.initFormType(PsOtherPaymentForm, [
                    'OtherPaymentType', w0,
                    'IsActive', w1,
                    'OtherPaymentName', w0,
                    'ProdImageLink', w2
                ]);
            }
        }
    }
}
